import { locationTypeEntityName, missionLocationEntityName, missionPositionEntityName, missionTypeEntityName, } from '../../../../../backend/config/classifiers';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { LocationTypeAdminPage } from '../LocationTypeAdminPage';
import { MissionLocationAdminPage } from '../MissionLocationAdminPage';
import { MissionPositionAdminPage } from '../MissionPositionAdminPage';
import { MissionTypeAdminPage } from '../MissionTypeAdminPage';
const groups = {
    missions: 'Missions',
};
const requireAnyManageMissionClassifierPermission = (userState, ...permissions) => {
    return requireAnySystemPermission(userState, 'manage-mission-classifiers', 'manage-all-classifiers', ...permissions);
};
export const getMissionAdminPages = (userState) => {
    const missionAdminPages = [];
    if (requireAnyManageMissionClassifierPermission(userState, 'manage-mission-location-type-classifier')) {
        missionAdminPages.push({
            label: 'Location Type',
            name: locationTypeEntityName,
            path: 'locationtype',
            groupLabel: groups.missions,
            component: LocationTypeAdminPage,
        });
    }
    if (requireAnyManageMissionClassifierPermission(userState, 'manage-mission-location-classifier')) {
        missionAdminPages.push({
            label: 'Mission Location',
            name: missionLocationEntityName,
            path: 'missionlocation',
            groupLabel: groups.missions,
            component: MissionLocationAdminPage,
        });
    }
    if (requireAnyManageMissionClassifierPermission(userState, 'manage-mission-type-classifier')) {
        missionAdminPages.push({
            label: 'Mission Type',
            name: missionTypeEntityName,
            path: 'missiontype',
            groupLabel: groups.missions,
            component: MissionTypeAdminPage,
        });
    }
    if (requireAnyManageMissionClassifierPermission(userState, 'manage-mission-position-classifier')) {
        missionAdminPages.push({
            label: 'Mission Position',
            name: missionPositionEntityName,
            path: 'missionPosition',
            groupLabel: groups.missions,
            component: MissionPositionAdminPage,
        });
    }
    return missionAdminPages;
};
